import { formatBRL, formatBrPhone, formatDateBR, formatDateTimeBR } from "@byfluent/domain";

export { formatBRL, formatBrPhone, formatDateBR, formatDateTimeBR };

export function brl(cents: number | null | undefined): string {
  return cents === null || cents === undefined ? "R$ 0,00" : formatBRL(Math.round(cents));
}

export function dateBR(value: string | Date | null | undefined): string {
  if (!value) return "";
  return typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)
    ? formatDateBR(value)
    : formatDateBR(new Date(value));
}

export function dateTimeBR(value: string | Date | null | undefined): string {
  if (!value) return "";
  return formatDateTimeBR(new Date(value));
}

/** "há 3 h", "há 2 dias" */
export function ago(value: string | Date | null | undefined): string {
  if (!value) return "";
  const ms = Date.now() - new Date(value).getTime();
  const min = Math.round(ms / 60_000);
  if (min < 1) return "agora";
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 24) return `há ${h} h`;
  const d = Math.round(h / 24);
  return `há ${d} ${d === 1 ? "dia" : "dias"}`;
}

export function monthLabel(key: string): string {
  const [y, m] = key.split("-").map(Number) as [number, number];
  const names = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];
  return `${names[m - 1]} de ${y}`;
}

export function percent(v: number): string {
  return `${(v * 100).toLocaleString("pt-BR", { maximumFractionDigits: 1 })}%`;
}

export function score(v: number | null | undefined): string {
  return v === null || v === undefined
    ? ""
    : v.toLocaleString("pt-BR", { maximumFractionDigits: 1 });
}

export function whatsappUrl(phone: string | null | undefined, text?: string): string {
  const digits = (phone ?? "").replace(/\D/g, "");
  return text
    ? `https://wa.me/${digits}?text=${encodeURIComponent(text)}`
    : `https://wa.me/${digits}`;
}
